import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printKeyValue } from '../../output.js'

export const workspacesGetCommand = new Command(`get`)
  .description(`Show workspace details`)
  .argument(`<id>`, `Workspace ID`)
  .action(async (workspaceId: string) => {
    const json = workspacesGetCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.workspaces.get({ workspaceId })

      if (isQuiet()) {
        printQuiet(result.id)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printKeyValue([
          [`ID:`, result.id],
          [`Name:`, result.name],
          [`Created:`, result.createdAt],
        ])
      }
    } catch (error) {
      await handleError(error, json)
    }
  })
